import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SentryService, SentrySeverityLevel } from '../sentry/sentry.service';

@Injectable()
export class WeguideHttpInterceptor implements HttpInterceptor {
  constructor(public sentrySvc: SentryService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          const err = {
            body: request.body,
            error,
          };
          console.error('error', err);
          this.sentrySvc.setMessageForSentryWithErrorInfo('Got 500 Error', SentrySeverityLevel.Critical, err);
        }
        return throwError(error);
      })
    );
  }
}
